const error = [{
  code: 401,
  title: 'Доступ запрещен',
  message: 'Для просмотра этой страницы необходимо <a href="/login">авторизоваться</a>'
}, {
  code: 403,
  title: 'Доступ запрещен',
  message: 'У вас нет доступа для просмотра этой страницы'
}, {
  code: 404,
  title: 'Не найдено',
  message: 'Запрошенная страница не найдена'
}, {
  code: 419,
  title: 'Сессия истекла',
  message: 'Время сессии истекло. <a href="/login">Авторизуйтесь</a> повторно'
}, {
  code: 429,
  title: 'Много запросов',
  message: 'Вы выполнили слишком много запросов'
}, {
  code: 500,
  title: 'Ошибка сервера',
  message: 'Ошибка сервера. Обратитесь к администратору'
}, {
  code: 503,
  title: 'Сервис недоступен',
  message: 'Сервис недоступен. Обратитесь к администратору'
}]

export default error



// WEBPACK FOOTER //
// ./src/store/error.js